import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Mahir Molai`}</h1>
    <p>{`I'm a javascript developer, who makes desktop apps using electron, and makes websites with things such as React.js, Express.js And GatsbyJS.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      